import { api } from "@/lib/api";
import { RecipeContent, StudioContentStatus } from "../schema";

const CONTENT_RECIPE = "/content-recipes";

export const ContentRecipeService = {
  async findAll(filters?: {
    search?: string;
    status?: StudioContentStatus;
    categoryId?: string;
    authorCoachId?: string;
    tagId?: string;
    language?: string;
    page?: number;
    limit?: number;
  }): Promise<{ items: RecipeContent[]; pagination: any }> {
    const params = new URLSearchParams();
    if (filters?.search) params.set("search", filters.search);
    if (filters?.status) params.set("status", filters.status);
    if (filters?.categoryId) params.set("categoryId", filters.categoryId);
    if (filters?.authorCoachId)
      params.set("authorCoachId", filters.authorCoachId);
    if (filters?.tagId) params.set("tagId", filters.tagId);
    if (filters?.language) params.set("language", filters.language);
    if (filters?.page) params.set("page", filters.page.toString());
    if (filters?.limit) params.set("limit", filters.limit.toString());

    return api.get<{ items: RecipeContent[]; pagination: any }>(
      `${CONTENT_RECIPE}?${params.toString()}`,
    );
  },

  async findOne(id: string): Promise<RecipeContent> {
    return api.get<RecipeContent>(`${CONTENT_RECIPE}/${id}`);
  },

  async create(payload: any): Promise<RecipeContent> {
    return api.post<RecipeContent>(CONTENT_RECIPE, payload);
  },

  async update(id: string, payload: any): Promise<RecipeContent> {
    return api.patch<RecipeContent>(`${CONTENT_RECIPE}/${id}`, payload);
  },

  async submitForReview(id: string): Promise<any> {
    return api.post(`${CONTENT_RECIPE}/${id}/submit`, {});
  },

  async createVersion(id: string): Promise<{ id: string; version: number }> {
    return api.post(`${CONTENT_RECIPE}/${id}/new-version`, {});
  },

  async archive(id: string): Promise<RecipeContent> {
    return api.delete<RecipeContent>(`${CONTENT_RECIPE}/${id}`);
  },

  async restore(id: string): Promise<RecipeContent> {
    return api.post<RecipeContent>(`${CONTENT_RECIPE}/${id}/restore`, {});
  },
};
